/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { SUBSCRIPTION_STATUS } from 'constants/subscription'
import { EMPTY_OBJECT } from 'constants/frozenObjects'
import { ROUTES } from 'constants/routes'
import { withLocalization } from 'hocs/localization'
import { getUserDetails } from 'api/client/actions/user'
import { onVerifyCurrentCard } from 'redux-app/actionCreators/users'
import { createAlert, onShowError } from 'redux-app/modules/alerts'
import { MODAL_CONFIRM_CHANGING_PLAN } from '../ConfirmChangingPlanModal'
import { MODAL_FORBIDDEN_CHANGING_PLAN } from '../ForbiddenChangingPlanModal'
import { openModal } from 'redux-app/modules/modals'
import {
  getUserSubscription,
  getUserFutureSubscription,
  isUserUnableToUpdateInfo,
  isUserAbleToCancelSubscription,
  getSubscriptionStatus,
  isUserAbleToChangeSubscription,
  isUserConfirmedEmail,
  isEnrollAvailable,
  isUserContractExpired,
  isChangeSubscriptionAllowed
} from 'redux-app/selectors/user'
import { CONFIRM_CANCEL_SUBSCRIPTION_MODAL_NAME } from './contants'
import ManageAccount from './ManageAccount'
import { ALERTS } from 'constants/alerts'

export default compose(
  connect(
    state => {
      const userSubscription = getUserSubscription(state) || EMPTY_OBJECT
      const futureSubscription = getUserFutureSubscription(state) || EMPTY_OBJECT
      const subscriptionStatus = getSubscriptionStatus(state)

      return {
        userSubscription,
        subscriptionStatus,
        futureSubscription,
        isUserConfirmedEmail: isUserConfirmedEmail(state),
        isUserAbleToChangeSubscription: isUserAbleToChangeSubscription(state) || futureSubscription !== EMPTY_OBJECT,
        isUserAbleToCancelSubscription: isUserAbleToCancelSubscription(state) || futureSubscription !== EMPTY_OBJECT,
        isUserUnableToUpdateInfo: isUserUnableToUpdateInfo(state),
        isEnrollAvailable: isEnrollAvailable(state),
        isUserContractExpired: isUserContractExpired(state),
        isChangeSubscriptionAllowed: isChangeSubscriptionAllowed(state),
      }
    },
    {
      openModal,
      getUserDetails,
      onVerifyCurrentCard,
      onShowError,
      createAlert,
    },
  ),
  withLocalization('profile.manageAccount'),
  withRouter,
  withHandlers({
    openChangingConfirm: ({
      openModal,
      getUserDetails,
      history,
    }) => () => {
      getUserDetails()
        .then(({ value: { result } }) => {
          const { subscription: {
            canChangeSubscriptionPlan,
            status,
            hasSubscriptionPlanChangeFee,
            upgradeFee,
            downgradeFee,
          } } = result
          if (canChangeSubscriptionPlan) {
            if (status === SUBSCRIPTION_STATUS.pendingConfirmation || !hasSubscriptionPlanChangeFee) {
              history.push(ROUTES.profile.changePlan.root)
              return
            }
            openModal({
              name: MODAL_CONFIRM_CHANGING_PLAN,
              data: {
                upgradeFee,
                downgradeFee,
              },
            })
          } else {
            openModal({
              name: MODAL_FORBIDDEN_CHANGING_PLAN,
            })
          }
        })
    },
    onOpenCancellationConfirm: ({ openModal, getUserDetails }) => () => {
      getUserDetails()
        .then(({ value: { result } }) => {
          const { subscription: { hasCancellationFee, cancellationFee } } = result
          openModal({
            name: CONFIRM_CANCEL_SUBSCRIPTION_MODAL_NAME,
            data: {
              hasCancellationFee,
              cancellationFee,
            },
          })
        })
    },
    onGoToRenewalProcess: ({ history, onVerifyCurrentCard, onShowError }) => () => {
      onVerifyCurrentCard().then(({ value: { result } }) => {
        history.push(ROUTES.profile.renewPlan.root)
        return
      })
      .catch(error => {
        onShowError(error)
      })
      return
    },
    onGoToChangePlanProcess: ({ history }) => () => {
      history.push(ROUTES.profile.changePlan.root)
      return
    },
    onGoToEnrollPlanProcess: ({ history, onVerifyCurrentCard, onShowError }) => () => {
      onVerifyCurrentCard().then(({ value: { result } }) => {
        history.push(ROUTES.profile.enrollPlan.root)
        return
      })
      .catch(error => {
        onShowError(error)
      })
    },
  }),
)(ManageAccount)
